import React from 'react';
import { useIntl } from 'react-intl-next';
import { messages } from '@atlaskit/editor-common/emoji';
import Emoji from '../ui/Emoji';
var EmojiAssistiveTextComponent = /*#__PURE__*/React.memo(function (_ref) {
  var emojiShortName = _ref.emojiShortName;
  var intl = useIntl();
  return /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 0
    }
  }, "".concat(intl.formatMessage(messages.emojiNodeLabel), " ").concat(emojiShortName));
});
export function EmojiNodeView(props) {
  var _props$node$attrs = props.node.attrs,
    shortName = _props$node$attrs.shortName,
    id = _props$node$attrs.id,
    text = _props$node$attrs.text;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(EmojiAssistiveTextComponent, {
    emojiShortName: shortName
  }), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Emoji, {
    providers: props.providerFactory,
    id: id,
    shortName: shortName,
    fallback: text
  })));
}